import {Injectable} from '@angular/core';
import {throwError as observableThrowError} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {RedirectService} from '../../../services/redirect.service';
import {ModalsControlService} from '../../../services/modals-control.service';
import {UrlBuilderService} from '../../../services/url-builder.service';
import {BookingParamsEnum} from '../enums/booking-enums';
import {HttpErrorResponse} from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class BookingV2ApiHelper {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private redirect: RedirectService,
    private modalControlService: ModalsControlService,
    private urlBuilder: UrlBuilderService,
  ) {}

  public handleError(error: Response | any, id?: number) {
    let errorMessage = '';
    if (error.error instanceof HttpErrorResponse) {
      errorMessage = `Error: ${error.error.message}`;
    } else {
      if (error.status >= 400) {
        console.error(`API RETURNED ${error.status}: ${JSON.stringify(error)}`);
        this.modalControlService.closeAll();
        const routerLink: string[] = this.urlBuilder.CreateInternalBookingRouterLink(id);
        routerLink.push(BookingParamsEnum.UNAVAILABLE);
        console.log('PUSHED UNAVAILABLE TO ROUTERLINK');
        this.redirect.redirect(routerLink, this.route.snapshot.queryParams, true);
      } else {
        errorMessage = `Error Code: ${error.status}\rMessage: ${error.message}`;
      }
    }
    return observableThrowError(errorMessage);
  }
}
